import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=632f5461&scoped=true"
import script from "./ShopList.vue?vue&type=script&lang=ts"
export * from "./ShopList.vue?vue&type=script&lang=ts"
import style0 from "./ShopList.vue?vue&type=style&index=0&id=632f5461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f5461",
  null
  
)

export default component.exports